import { MenuItem, TextField } from "@mui/material";
import { useGetSellers } from "../../../services/usersApi";

export const SellerSelect = (props) => {
    const { label, selectedSellerId, setSelectedSellerId, disabled = false } = props;

    const { data: sellers, isLoading } = useGetSellers();

    return (
        <TextField
            select
            label={label}
            fullWidth
            value={selectedSellerId}
            onChange={(e) => setSelectedSellerId(e.target.value)}
            disabled={disabled || isLoading}
            SelectProps={{
                sx: { textAlign: "left" },
            }}
        >
            {sellers?.map((seller) => (
                <MenuItem key={seller.id} value={seller.id}>
                    {seller.full_name}
                </MenuItem>
            ))}
        </TextField>
    );
};
